export default {"src":"/_next/static/media/clien-family-socialization.0a650f5b.svg","height":500,"width":500};